// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gradient-btn:hover{background:linear-gradient(270deg,#dcca87,#dcca87,rgba(220,202,135,.23922))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
